export const CHALLENGE_ISSUE_NOTE_MAX_LENGTH = 500;
